<template>
  <v-card class="card-wrap">
    <v-card class="pa-1 my-2 elevation-0">
      <!-- eslint-disable-next-line prettier/prettier -->
        <single-line-data-table
          :headers="headers"
          :items="dataList"
          :loading="loading"
          :height="height"
          @click:row="clickRow"
          single-select
          fixed-header
          disable-pagination
          dense 
          hide-default-footer>
      </single-line-data-table>
    </v-card>
  </v-card>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { api } from '@/api/common/instances';
import bus from '@/utils/bus';
import settingsGrid from '@/components/motlet/settings/grid';
import SingleLineDataTable from '@/components/grid/SingleLineDataTable';

export default {
  components: {
    SingleLineDataTable,
  },
  props: {
    sstmId: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    gridCode: {
      type: String,
      default() {
        return this.code;
      },
    },
    eventCode: String,
    selected: {
      type: Array,
      required: true,
    },
    clickRow: {
      type: Function,
      default() {
        return function() {};
      },
    },
    height: {
      type: Number,
      default: 100,
    },
    firstRowSelected: {
      type: Boolean,
      default: false,
    },
    rowSelectedEmitName: String,
    onFetch: {
      type: Function,
      default() {
        return () => {};
      },
    },
    storeName: String,
    nodes: Array,
    timestamp: {
      type: Number,
      required: true,
    },
    items: Array,
  },
  data() {
    return {
      list: [],
      loading: false,
      datetime: null,
    };
  },
  watch: {
    descendants: {
      deep: true,
      handler() {
        if (this.datetime) this.fetchData(this.datetime);
      },
    },
    // BEGIN::Added.by.KWShin.2025.11.26.
    descendant: {
      deep: true,
      handler() {
        if (this.datetime) this.fetchData(this.datetime);
      },
    },
    // FINISH::Added.by.KWShin.2025.11.26.
    timestamp: {
      immediate: true,
      handler(value) {
        // Added.by.KWShin.2025.11.26.
        // 아놔... 오만군데서 this.datetime을 체크하고 사용하면서 적장 값을 할당하는 데는 없네... 그래서 추가.
        this.datetime = value;
        this.fetchData(value);
      },
    },
  },
  computed: {
    headers() {
      return settingsGrid[this.gridCode].fields.filter(h => this.selected.includes(h.value));
    },
    onEventCode() {
      return this.eventCode || this.code;
    },
    descendants() {
      return this.storeName ? this.$store.getters[`${this.storeName}/get`] : this.nodes ?? [];
    },
    descendant() {
      return (this.descendants || []).find(d => d.active);
    },
    dataList: {
      get() {
        return this.items ?? this.list;
      },
      set(data) {
        this.$emit('update:items', data);
        this.list = data;
      },
    },
  },
  methods: {
    async fetchData(datetime) {
      this.loading = true;
      // BEGIN::Modified.by.KWShin.2025.11.26.
      // const params = {
      //   endYmdhms: datetime,
      //   sstmId: this.sstmId,
      //   instId: this.descendant.instanceId,
      //   nodeId: this.descendant.nodeId,
      //   motletCode: this.code,
      // };
      const params = {
        endYmdhms: datetime,
        sstmId: this.sstmId,
        motletCode: this.code,
      };
      // active가 아닌 게 하나도 없으면 전체 노드가 선택된 상태임.
      const allNode = this.descendants.find(d => d.active == false) == undefined ? true : false;
      // 전체 노드가 선택된 상태가 아니면 현재 선택된 노드만 조회하게끔 패러미터 추가
      if (allNode == false) {
        params.instId = this.descendant.instanceId;
        params.nodeId = this.descendant.id;
      }
      // FINISH::Modified.by.KWShin.2025.11.26.
      // BEGIN::Modified.by.KWShin.2025.11.26.
      // const {
      //   data: [{ data }],
      // } = await api.get('/motlet-data/grid', { params });
      // this.dataList = data.map(d => ({ id: uuidv4(), ...d }));
      // 전체 노드 데이터가 읽혀온 경우와 1개의 노드 데이터만 읽어온 경우 모두를 고려해야함.
      this.dataList = [];
      const response = await api.get('/motlet-data/grid', { params });
      response.data.forEach(rspn => {
        this.dataList = this.dataList.concat(rspn.data.map(d => ({ id: uuidv4(), ...d })));
      });
      // FINISH::Modified.by.KWShin.2025.11.26.

      if (this.firstRowSelected) {
        const [row] = this.dataList;
        (row || {}).isSelected = true;
        if (this.rowSelectedEmitName) bus.$emit(this.rowSelectedEmitName, row);
      }

      this.onFetch({ eventCode: this.onEventCode, data: this.dataList });
      this.loading = false;
    },
  },
};
</script>
